import { cn, DATE_PRESETS, type DatePreset } from "@/lib/utils";

export function DatePresetPicker({
  active,
  onSelect,
}: {
  active: DatePreset;
  onSelect: (key: DatePreset, start: string, end: string) => void;
}) {
  return (
    <div className="flex gap-1">
      {DATE_PRESETS.map((p) => (
        <button
          key={p.key}
          onClick={() => {
            const [s, e] = p.range();
            onSelect(p.key, s, e);
          }}
          className={cn(
            "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
            active === p.key
              ? "bg-primary text-primary-foreground"
              : "bg-muted text-muted-foreground hover:bg-muted/80",
          )}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
